import React from "react";
import renderIcon from "../../../components/renderIcon";

/**
 * Note /5 en étoiles, avec demi-étoiles. Partagé entre attractions / hôtels /
 * restaurants (champ `note` saisi par le Beth Habad).
 *
 * Props :
 *   - value: number (0–5, demi-points). Si falsy/0 → ne rend rien (null).
 *   - size: number (px, défaut 16).
 *   - showValue: boolean — affiche aussi la valeur numérique à côté (défaut false).
 *
 * Styles encapsulés sous `.tr-stars__*` (injectés une fois, idempotents via id).
 */

const styles = `
.tr-stars { display: inline-flex; align-items: center; gap: 2px; line-height: 1; color: #f5a623; }
.tr-stars__icon { display: inline-flex; }
.tr-stars__icon--empty { color: #d1d5db; }
.tr-stars__value { margin-inline-start: 6px; font-size: .85em; font-weight: 600; color: #374151; }
`;

export default function StarRating({ value, size = 16, showValue = false }) {
    const v = Number(value);
    if (!v || v <= 0) return null;

    const clamped = Math.max(0, Math.min(5, v));

    const stars = [];
    for (let i = 1; i <= 5; i++) {
        let icon;
        let cls = "tr-stars__icon";
        if (clamped >= i) {
            icon = { name: "IconStarFilled", source: "tabler" };
        } else if (clamped >= i - 0.5) {
            icon = { name: "IconStarHalfFilled", source: "tabler" };
        } else {
            icon = { name: "IconStar", source: "tabler" };
            cls += " tr-stars__icon--empty";
        }
        stars.push(
            <span key={i} className={cls}>
                {renderIcon(icon, size)}
            </span>
        );
    }

    return (
        <span className="tr-stars" aria-label={`${clamped}/5`}>
            <style dangerouslySetInnerHTML={{ __html: styles }} />
            {stars}
            {showValue && <span className="tr-stars__value">{clamped}</span>}
        </span>
    );
}
